import React, { PropsWithChildren, PureComponent } from 'react';

interface EnhancedIconProps {
    disabled?: boolean;
    onClick?(): void;
}

export class EnhancedIcon extends PureComponent<PropsWithChildren<EnhancedIconProps>> {
    onClick = () => {
        if (!this.props.disabled) {
            this.props.onClick?.();
        }
    };
    render() {
        return (
            <span
                onClick={this.onClick}
                style={this.props.disabled ? { opacity: '0.5', cursor: 'not-allowed' } : { cursor: 'pointer' }}>
                {this.props.children}
            </span>
        );
    }
}
